// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  width: 664,
  height: 700,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: undefined,
      stateByName: {}
    },
    {
      id: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      type: 'Container',
      runtimeType: null,
      name: 'popup',
      className: '',
      x: 335,
      y: 462,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'dc1832c7-ea6a-481b-930b-9d3177766f59',
      type: 'Sprite',
      runtimeType: null,
      name: 'placeholderBG',
      className: '',
      x: -1,
      y: -96,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85641,
        y: 0.625
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'bg',
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      data: undefined,
      stateByName: {}
    },
    {
      id: '95d277a4-48d9-4457-89db-a8b0faa57854',
      type: 'Sprite',
      runtimeType: null,
      name: 'background',
      className: '',
      x: -1,
      y: -78,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 0.740132
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Small_Pop_Up_Background',
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      data: undefined,
      stateByName: {
        game: {
          scale: {
            y: 1.17
          },
          y: -18
        }
      }
    },
    {
      id: '2ad1319f-470b-4b78-88d0-1efa0ac3a070',
      type: 'Container',
      runtimeType: null,
      name: 'confirmButton',
      className: '',
      x: -140,
      y: 15,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 1,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      data: undefined,
      stateByName: {
        noDoubleCoins: {
          visible: false
        }
      }
    },
    {
      id: '3c0612f0-de4d-4a01-8a69-d260310dda25',
      type: 'Container',
      runtimeType: null,
      name: 'cancelButton',
      className: '',
      x: 140,
      y: 15,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 1,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      data: undefined,
      stateByName: {
        noDoubleCoins: {
          visible: false
        }
      }
    },
    {
      id: '7f863a7e-000c-41d2-9f3a-09381c2f227f',
      type: 'Container',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 10,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      data: undefined,
      stateByName: {
        game: {
          scale: {
            y: 1.2,
            x: 1.2
          },
          y: 30
        }
      }
    },
    {
      id: '31c4b118-6d9a-49a2-bb99-3543ace30601',
      type: 'Sprite',
      runtimeType: null,
      name: 'header',
      className: '',
      x: 0,
      y: -300,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.849372,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Red_Header',
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      data: undefined,
      stateByName: {}
    },
    {
      id: '69551968-9529-4083-9063-7d6a04eee1ba',
      type: 'Sprite',
      runtimeType: null,
      name: 'closeButton',
      className: '',
      x: 266,
      y: -340,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -73,
        y: -75,
        width: 140,
        height: 144
      },
      texture: 'Close_Button',
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      data: {
        tapSound: 'UI_Button_Click'
      },
      stateByName: {}
    },
    {
      id: '27b68a7a-7316-4a37-86f6-1edce4b23124',
      type: 'NineSlicePlane',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 138,
        y: 55
      },
      width: 276,
      height: 110,
      leftWidth: 55,
      topHeight: 55,
      rightWidth: 55,
      bottomHeight: 55,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Button_Green',
      parent: '2ad1319f-470b-4b78-88d0-1efa0ac3a070',
      data: undefined,
      stateByName: {}
    },
    {
      id: '8348efc0-5dbc-48f7-8722-7f07ba823990',
      type: 'Text',
      runtimeType: null,
      name: 'updateButtonText',
      className: '',
      x: 2,
      y: -7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Love it!',
      localize: true,
      maxWidth: 186,
      maxHeight: 101,
      maxFontSize: 0,
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#c63300',
        strokeThickness: 7,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 40,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '2ad1319f-470b-4b78-88d0-1efa0ac3a070',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'cf86d8dd-a203-4492-86c3-a7682a79d981',
      type: 'NineSlicePlane',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 138,
        y: 55
      },
      width: 276,
      height: 110,
      leftWidth: 55,
      topHeight: 55,
      rightWidth: 55,
      bottomHeight: 55,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Button_Red',
      parent: '3c0612f0-de4d-4a01-8a69-d260310dda25',
      data: null,
      stateByName: {}
    },
    {
      id: 'fa6eb79c-0137-4e90-9b6a-5049f41377da',
      type: 'Text',
      runtimeType: null,
      name: 'updateButtonText',
      className: '',
      x: 2,
      y: -7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Not really',
      localize: true,
      maxWidth: 186,
      maxHeight: 101,
      maxFontSize: 0,
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#c63300',
        strokeThickness: 7,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 40,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '3c0612f0-de4d-4a01-8a69-d260310dda25',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'ae8f8024-c22b-4a1a-90a4-4c652b4c7dca',
      type: 'Text',
      runtimeType: null,
      name: 'messageText',
      className: '',
      x: 0,
      y: -140,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Your feedback helps us make the game even better.',
      localize: false,
      maxWidth: 500,
      maxHeight: 520,
      maxFontSize: 0,
      style: {
        fontSize: 39,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x712316',
        strokeThickness: 7,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 400,
        breakWords: false,
        lineHeight: 35,
        padding: 3,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '7f863a7e-000c-41d2-9f3a-09381c2f227f',
      data: undefined,
      stateByName: {
        game: {
          maxWidth: 300,
          y: 20,
          style: {
            fontSize: 34,
            lineHeight: 33,
            fill: 'white',
            stroke: '#e84302',
            strokeThickness: 7,
            fontFamily: 'Baloo{wf}',
            padding: 0,
            wordWrap: true,
            wordWrapWidth: 250,
            align: 'center',
            dropShadow: false,
            dropShadowAlpha: 1,
            fillGradientType: 0,
            fillGradientStops: '',
            fontVariant: 'normal',
            whiteSpace: 'pre',
            lineJoin: 'round',
            baseline: 'alphabetic',
            fontStyle: 'normal',
            letterSpacing: 0,
            leading: 0,
            trim: false,
            miterLimit: 10,
            breakWords: false,
            fontWeight: 'lighter',
            dropShadowDistance: 5,
            dropShadowColor: 'black',
            dropShadowBlur: 0,
            dropShadowAngle: 0
          }
        },
        'main-menu': {
          maxWidth: 300
        },
        'main-menu-max-lives': {
          style: {
            wordWrap: true,
            wordWrapWidth: 250,
            stroke: '#e84302',
            fill: 'white',
            fontSize: 28,
            strokeThickness: 7,
            fontFamily: 'Baloo{wf}',
            padding: 0,
            align: 'center',
            dropShadow: false
          },
          text: 'Maximum amount of lives',
          localize: true
        }
      }
    },
    {
      id: '6110fb58-4e31-43e0-b59e-22367159183d',
      type: 'Text',
      runtimeType: null,
      name: 'titleText',
      className: '',
      x: -3,
      y: -9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Enjoying?',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      style: {
        fontSize: 55,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x840025',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '31c4b118-6d9a-49a2-bb99-3543ace30601',
      data: undefined,
      stateByName: {
        game: {
          text: 'Out of Lives'
        }
      }
    }
  ],
  version: '1.0.0',
  stateNames: [
    'game',
    'main-menu',
    'main-menu-max-lives'
  ],
  animations: []
} as const;

export class RateUsPopupLayout {
  static raw = raw;
  root: Container;
  popup: Container;
  placeholderBG: Sprite;
  background: Sprite;
  confirmButton: Container;
  cancelButton: Container;
  header: Sprite;
  closeButton: Sprite & { data: typeof raw['list'][8]['data'] };
  updateButtonText: Text;
  messageText: Text;
  titleText: Text;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: 'game' | 'main-menu' | 'main-menu-max-lives';
    ModelByName: {
      root: typeof raw['list'][0];
      popup: typeof raw['list'][1];
      placeholderBG: typeof raw['list'][2];
      background: typeof raw['list'][3];
      confirmButton: typeof raw['list'][4];
      cancelButton: typeof raw['list'][5];
      header: typeof raw['list'][7];
      closeButton: typeof raw['list'][8];
      updateButtonText: typeof raw['list'][10];
      updateButtonText: typeof raw['list'][12];
      messageText: typeof raw['list'][13];
      titleText: typeof raw['list'][14];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
